import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TripBookingGuideline } from '../../lib/types/models/trip-booking/trip-booking-guildeline'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripBookingGuidelines(input: PaginationRequest = {}) {
  if (!input.sort) input.sort = { label: 'asc' }

  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.tripBookingGuidelines.getAll.url, null), input))
    .get<PaginationResponse<TripBookingGuideline>>()
}
